import { SxProps, styled } from "@mui/material";
import { PickersDay, PickersDayProps } from "@mui/x-date-pickers";
import { DateTime, Interval } from "luxon";

interface CustomDateRangeDayProps extends PickersDayProps<DateTime> {
    isSelected: boolean
    isHovered: boolean
    isFromDate: boolean
    isToDate: boolean
    isInRangeDates: boolean
}

const isFromDateStyle: any = {
    backgroundColor: `#1976d2`,
    color: `#FFF`,
    borderRadius: '50%'
}

const isToDateStyle: any = {
    backgroundColor: `#1976d2`,
    color: `#FFF`,
    borderRadius: '50%'
}

const isInRangeStyle: any = {
    backgroundColor: `rgba(25, 118, 210, 0.2)`
}


export const CustomDateRangeDay = styled(PickersDay, {
    shouldForwardProp: (prop) => prop !== 'isSelected'
        && prop !== 'isHovered'
        && prop !== 'isFromDate'
        && prop !== 'isToDate'
        && prop !== 'isInRangeDates',
})<CustomDateRangeDayProps>(({ theme, isSelected, isHovered, day, isFromDate, isToDate, isInRangeDates  }) => ({
    borderRadius: 0,
    //...(isSelected && {
    //    backgroundColor: theme.palette.primary.main,
    //    color: theme.palette.primary.contrastText,
    //    '&:hover, &:focus': {
    //        backgroundColor: theme.palette.primary.main,
    //    },
    //}),
    // ...(isFromDate && isFromDateStyle),
    ...(isInRangeDates && isInRangeStyle),
    ...(isFromDate && isFromDateStyle),
    ...(isToDate && isToDateStyle),
    '&:hover': {
    
    },
    //...(isHovered && {
    //    backgroundColor: theme.palette.primary.light,
    //    '&:hover, &:focus': {
    //        backgroundColor: theme.palette.primary.light,
    //    },
    //    ...theme.applyStyles('dark', {
    //        backgroundColor: theme.palette.primary.dark,
    //        '&:hover, &:focus': {
    //            backgroundColor: theme.palette.primary.dark,
    //        },
    //    }),
    //}),
    //...(day.weekday === 1 && {
    //    borderTopLeftRadius: '50%',
    //    borderBottomLeftRadius: '50%',
    //}),
    //...(day.weekday === 7 && {
    //    borderTopRightRadius: '50%',
    //    borderBottomRightRadius: '50%',
    //}),
})) as React.ComponentType<CustomDateRangeDayProps>;

const isInSameWeek = (dayA: DateTime, dayB: DateTime | null | undefined) => {
    if (dayB == null) {
        return false;
    }

    //return dayA.isSame(dayB, 'week');

    return dayA.weekNumber === dayB.weekNumber
};

const isSameDate = (dayA: DateTime | null | undefined, dayB: DateTime | null | undefined): boolean => {
    if (dayA && dayB) {
        const result = dayA.hasSame(dayB, 'day') && dayA.hasSame(dayB, 'month') && dayA.hasSame(dayB, 'year')

        return result
    }

    return false
}

const inRangeDate = (interval: Interval, day: DateTime | null | undefined): boolean => {
    if (interval && day) {
        const result = interval.contains(day)

        return result
    }

    return false
}

export const Day = (
    props: PickersDayProps<DateTime> & {
        selectedDay?: DateTime | null;
        hoveredDay?: DateTime | null;
        startDate?: DateTime | null;
        endDate?: DateTime | null;

    },
) => {
    const { day, selectedDay, hoveredDay, startDate, endDate, ...other } = props;

    const handleInRangeDates = () => {
        if (startDate && endDate && day) {
            return inRangeDate(Interval.fromDateTimes(startDate, endDate), day)
        }

        return false
    }

    return (
        <CustomDateRangeDay
            {...other}
            day={day}
            sx={{ px: 2.5 }}
            disableMargin
            selected={false}
            isSelected={isInSameWeek(day, selectedDay)}
            isHovered={isInSameWeek(day, hoveredDay)}
            isFromDate={isSameDate(day, startDate)}
            isToDate={isSameDate(day, endDate)}
            isInRangeDates={handleInRangeDates()}
        />
    );
}